<template>
  <a href="/2013/VIZBI_2013_Poster.pdf" target="_blank">
    <img
      src="/2013/VIZBI-2013-Poster-11x17.jpg"
      alt="VIZBI 2013 conference poster"
      class="poster"
      title="Click here to download the VIZBI conference poster" />
  </a>
  <p>
    VIZBI 2013, the 4<sup>th</sup> international meeting on Visualizing Biological Data, was held
    March 20&ndash;22, at the
    <a href="http://www.broadinstitute.org/">Broad Institute of MIT and Harvard</a>, Cambridge MA,
    USA. VIZBI 2013 brought together scientists, illustrators, and designers actively using or
    developing computational visualization to study a diverse range of biological data.
  </p>
  <p>
    The conference featured
    <router-link to="People">21 invited talks</router-link> that reviewed the state-of-the-art and
    challenges in visualizing data from genomes, transcripts, proteins, cells, organisms, and
    populations. Prior to the meeting (March 19), there were
    <router-link to="Program">tutorials</router-link> on several visualization tools.
  </p>
  <p>
    All VIZBI 2013 participants had the opportunity to present a poster describing their work.
    Posters from VIZBI 2013 are accessible at
    <a href="http://vizbi.org/Posters/2013/">vizbi.org/Posters/2013</a>.
  </p>
  <p>
    Funding for this conference was made possible in part by NIH grant R13LM010987. The views
    expressed in written conference materials or publications and by speakers and moderators do not
    necessarily reflect the official policies of the Department of Health and Human Services; nor
    does mention of trade names, commercial practices, or organizations imply endorsement by the
    U.S. Government.
  </p>
</template>

<style scoped>
img.poster {
  float: right;
  margin: 0 0 12px 12px;
  max-width: 240px;
  width: 35%;
  height: auto;
}
</style>
